import { render, staticRenderFns } from "./DefaultSlotTime.vue?vue&type=template&id=98161720"
import script from "./DefaultSlotTime.vue?vue&type=script&lang=js"
export * from "./DefaultSlotTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports